import Advertiser from 'routes/Dictionaries/Advertiser/containers/AdvertiserContainer';

export default Advertiser;
